import { render, staticRenderFns } from "./DeclineTest.vue?vue&type=template&id=c4ee78ce&"
import script from "./DeclineTest.vue?vue&type=script&lang=js&"
export * from "./DeclineTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports